import React from "react";
import { styled } from "@mui/material/styles";
import { Stack, Typography, Box } from "@mui/material";

const Text = styled(Typography)(({ theme }) => ({
  fontStyle: "italic",
  color: theme.palette.text.light,
  fontSize: "0.8rem",
  marginTop: 10,
}));

function Icon({ url, text, textcolor = null }) {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      my={0.3}
    >
      <img
        src={url}
        alt="Beach Icon"
        style={{
          width: "25px",
          height: "25px",
          marginRight: "0.5rem",
        }}
      />
      <Text sx={{ color: !textcolor ? text.light : "black" }}>{text}</Text>
    </Stack>
  );
}

export default Icon;
